export default __webpack_public_path__ + "images/siteLoginImage.fe2f93bd.svg";